export default {
      id: "takeaway-usage",
      viewBox: "0 0 53.049 53.082",
      url: "../../assets/" + "sprite.svg#takeaway-usage",
      toString: function () {
        return this.url;
      }
    }